module.exports = __webpack_public_path__ + "img/iphone-map-GERMANY-de.70683468.png";